// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Oq-z","imageAndVideoCount":"Pq-z","imageAndVideoContainer":"Qq-z","viewAllReviews":"Rq-z"};